import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import settings from './config/settings';

import Header from './components/Header';
import Footer from './components/Footer';
import FloatingCTAs from './components/FloatingCTAs';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import About from './pages/About';
import Academics from './pages/Academics';
import Program from './pages/Program';
import CBSE from './pages/CBSE';
import Gallery from './pages/Gallery';
import Teachers from './pages/Teachers';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-out-cubic',
      once: true,
      offset: 50
    });

    // Set document title from settings
    document.title = settings.meta.title;
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-white">
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/academics" element={<Academics />} />
            <Route path="/program" element={<Program />} />
            <Route path="/cbse" element={<CBSE />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/teachers" element={<Teachers />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCTAs />
        
        {/* Modal Portal Root */}
        <div id="modal-root"></div>
      </div>
    </Router>
  );
}

export default App;